import React, { forwardRef, useState } from 'react'

import Image from 'next/image'

import { Text } from 'Components/UI'

import { TRANSITION } from 'Constants/Animations'

import { Container, Overlay } from './styles'

import { LearnSectionGalleryItem } from '../constants'

type Props = {
  data: LearnSectionGalleryItem
}

const ImageHolder = forwardRef<HTMLDivElement, Props>(({ data }, ref) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Container
      ref={ref}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Image
        alt={data.name + ' ' + data.caption}
        height={160}
        src={data.image.src}
        width={160}
      />

      <Overlay
        animate={{ opacity: isHovered ? 1 : 0 }}
        initial={{ opacity: 0 }}
        transition={TRANSITION.DEFAULT}
      >
        <Text bold inverse screen20>
          {data.name}
        </Text>
      </Overlay>
    </Container>
  )
})

ImageHolder.displayName = 'ImageHolder'

export default ImageHolder
